export default __webpack_public_path__ + "static/hero-poster-83f711f211706fb233fd52c017ddef6d.webp";